import { Avatar, Checkbox, Button, Container, CssBaseline, FormControlLabel, Grid, makeStyles, TextField, Typography, InputLabel, Select, MenuItem, FormControl, CircularProgress, Modal } from '@material-ui/core';
import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import firebase from "firebase";
import upute from '../../images/uputeRad.PNG'
import emailjs from "emailjs-com";
  
  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

function PrijavaPredavac() {

    const  storageRef = firebase.storage().ref();
    const classes = useStyles();

    const [vrstaPredavanja, setvrstaPredavanja] = useState(null)

    const [uploadPercent,setUploadPercent] = useState(0)
    const [openModal,setOpenModal] = useState(false)

    
    const hisotry = useHistory()

    function handleChange(e){
        setvrstaPredavanja(e.target.value)
    }

    function handleReDirect(e){
      hisotry.push("/")
    }


    function handleCloseModal(e){
      setOpenModal(false)
    }

    function handleSubmit(e){

        
        e.preventDefault();
        
        setOpenModal(true)  

        let rad = e.target.strucniRad.files[0]
    
        let newPostKey = e.target.ime.value +"_" +e.target.prezime.value+"_"+Math.floor(Math.random() * 1000) + 1+"_"+Math.floor(Math.random() * 1000) + 1;
        
       

        emailjs
        .send(
          "serviceProba",
          "prijavaPredavac",
          {
            naziv: e.target.naziv.value,
            email: e.target.email.value,
          },
          "user_hU4wKMTGiLWs2jfLyPHR4"
        )
        .then((res) => {
          // TODO SPINNER AND DISABLE PAGE
          let uploadTask = storageRef.child('/Predavaci/Radovi/' + newPostKey + '/'+ rad.name).put(rad);
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function(snapshot) {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              setUploadPercent((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
            },
            function(errors){},
            function(){
              uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                console.log('File available at', downloadURL);
                const predavac = {
                  name:e.target.ime.value,
                  surname:e.target.prezime.value,
                  email:e.target.email.value,
                  naziv:e.target.naziv.value,
                  broj_sudionika:e.target.broj.value,
                  opis:e.target.opis.value,
                  vrijeme:e.target.vrijeme.value,
                  namjeneno:e.target.namjeneno.value,
                  vrsta:vrstaPredavanja,
                  time:new Date().toLocaleDateString(),
                  pribor:e.target.pribor.value,
                  cilj:e.target.cilj.value,
                  urlRad:downloadURL,
                }
  
  
                var updates = {};
                updates['Predavaci/prijave/' + newPostKey] = predavac;
                             
                 firebase.database().ref().update(updates);
        
  
                 setUploadPercent(0)
  
  
           
  
              });
            }
          )
  
        })
        .catch((err) => {
          alert("Pogreška pri slanju Pokušaj te kasnije ponovno");
          console.log(err);
        });
  


     


 
      }

      
  


    return (

     <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
        </Avatar>
        <Typography component="h1" variant="h3">
            
          Prijava Predavača
        </Typography>
        <form className={classes.form} onSubmit={(e)=>{handleSubmit(e)}}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"

            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="ime"
            label="Ime"
            type="text"
            id="ime"

          />
        <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="prezime"
            label="Prezime"
            type="text"
            id="prezime"
          />
         
            <br></br>
            <br/>
            <FormControl className={classes.formControl}>
        <InputLabel id="demo-simple-select-label">Vrsta izlaganja</InputLabel>
        <Select
        style={{width:"450px"}}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={vrstaPredavanja}
          onChange={handleChange}
        >
          <MenuItem value={"Predavanje"}>Predavanje</MenuItem>
          <MenuItem value={"Radionica"}>Radionica</MenuItem>

         
        </Select>
      </FormControl>


      <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="naziv"
            label={vrstaPredavanja==null?"Naziv":"Naziv " +vrstaPredavanja} 
            type="text"
            id="naziv"
          />

   

        <TextField 
        
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="cilj"
        label={vrstaPredavanja==null?"Ciljevi i zadaci":"Ciljevi i zadaci " +vrstaPredavanja} 
        type="text"
        multiline
        rows={4}
        id="cilj"
     
      />
         <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputProps={{ inputProps: { min: 10, max: 120 } }}
            name="vrijeme"
            label="Trajanje ( min)"
            type="number"
            id="vrijeme"
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="broj"
            InputProps={{ inputProps: { min: 5, max: 90 } }}
            label="Broj Sudionika"
            type="number"
            id="broj"
          />

          
        <TextField 
        
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="pribor"
        label="Potreban Pribor (geometrijski pribor, udžbenik i zbirka zadataka...)"
        type="text"
        multiline
        rows={4}
        id="pribor"
     />
        <TextField 
        
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="opis"
        label="Opis"
        type="text"
        multiline
        rows={4}
        id="opis"
     
      />
         <TextField 
        
        variant="outlined"
        margin="normal"
        required
        fullWidth
        name="namjeneno"
        label="Namjenjeno (učiteljima ili nastavnicima ili obima)"
        type="text"
        multiline
        rows={4}
        id="namjeneno"
     
      />

        <Typography title>
            UPUTE ZA PISANJE RADA
        </Typography>
       
        <div>
        <img src={upute}/>
        </div>
        <Typography>
              Stručni Rad
          </Typography>
        <Grid >
        <input
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="strucniRad"
            label="Stručni Rad"
            type="file"
            id="strucniRad"
            accept="application/pdf,application/msword,
            application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          />
</Grid>
        
       
        
        <Container style={{textAlign:"center"}}>
        <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submit}
            style={{width:"50%",textAlign:"center"}}
          >
              Prijavi Se
          </Button>
          </Container>
         
        </form>
      </div>


       {/* START MODAL */}
       <React.Fragment>
              <Modal
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{margin:"20px auto",width:"50%",height:"50%",backgroundColor:"white",overflow:"scroll",border:"2px solid lightblue"}}
             
              >
                
             
                  <React.Fragment style={{backgroundColor:"white"}}>
                    <Grid container direction="column" textAlign="center" style={{backgroundColor:"white",textAlign:"center",height:"100%"}} >
                    { uploadPercent >0 ? 
                    <React.Fragment>
                      <Grid item>
                      <Typography variant="h1">{uploadPercent} % <br/> Dovršena Obrada</Typography>
                      </Grid>
                    <CircularProgress/>
                    </React.Fragment>:
                    <Grid item>
                  <React.Fragment style={{backgroundColor:"white",width:"50%",marginTop:"20px",border:"2px solid lightblue"}}>
                    <Typography variant="h3" style={{marginTop:"50px"}}>Za sva dodatna pitanja kontaktirajte nas</Typography>
                    
                    
                    <Button onClick={handleReDirect} style={{backgroundColor:"#1F94C2",color:"white",width:"50%",marginTop:"20px"}} >Završite prijavu</Button>
                  </React.Fragment>
                  </Grid>

                }
                   </Grid>
                  </React.Fragment>
                
               
               
              </Modal >
            </React.Fragment>
            
             {/* END MODAL */}

    </Container>
   
    )
}

export default PrijavaPredavac
